module.exports = __webpack_public_path__ + "img/google-app-qr-code.ca01a40d.png";